export default {
  telephone: /^[+]?[0-9\ ]{7,20}$/,
  email: /^[^\s]+@[^\s]+\.[^\s]+$/i,
};



/** WEBPACK FOOTER **
 ** ./src/constants/validationRegexes.js
 **/